import { render, staticRenderFns } from "./expertlist.vue?vue&type=template&id=bf8fcd62&scoped=true"
import script from "./expertlist.vue?vue&type=script&lang=js"
export * from "./expertlist.vue?vue&type=script&lang=js"
import style0 from "./expertlist.vue?vue&type=style&index=0&id=bf8fcd62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8fcd62",
  null
  
)

export default component.exports